module.exports = __webpack_public_path__ + "static/media/S3N6-3.efac04a8.svg";